var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown"},[(_vm.format)?_vm._t("default",null,{"time":_vm.formatCountdown(_vm.timeDiff)}):_vm._t("default",null,{"time":_vm.timeDiff})],2)}
var staticRenderFns = []

export { render, staticRenderFns }